module.exports = __webpack_public_path__ + "7d8c32fa64ce19d2f47e8b60bb86e3dd.pdf";